import { render, staticRenderFns } from "./CellEditor.vue?vue&type=template&id=54dfe5f6"
import script from "./CellEditor.vue?vue&type=script&lang=js"
export * from "./CellEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports